var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preload_bg"},[_c('hermitage-logo',{staticClass:"preloader",attrs:{"id":"preload_logo"}}),_vm._v(" "),_c('div',{staticClass:"loading_line"},[_c('span',[_vm._v(_vm._s(_vm.counter)+"%")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }